// contexts/LanguageContext.js — app-wide EN/PL language with localStorage persistence.
// t(key, fallback) returns the active language string, falling back to English then
// to the provided fallback, so untranslated keys degrade gracefully to English.
import React, { createContext, useContext, useState, useCallback } from 'react';
import { STRINGS, LANGUAGES } from '../i18n/translations';

const LanguageContext = createContext(null);
const STORAGE_KEY = 'photoapp_lang';

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved && STRINGS[saved] ? saved : 'en';
  });

  const setLang = useCallback((code) => {
    if (!STRINGS[code]) return;
    localStorage.setItem(STORAGE_KEY, code);
    setLangState(code);
  }, []);

  const t = useCallback((key, fallback) => {
    return STRINGS[lang]?.[key] ?? STRINGS.en?.[key] ?? fallback ?? key;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext) || { lang: 'en', setLang: () => {}, t: (k, f) => f ?? k, languages: LANGUAGES };
}
